"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _OrderDetail = _interopRequireDefault(require("./components/OrderDetail.vue"));
var _VerifyOrderDialog = _interopRequireDefault(require("./components/VerifyOrderDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderList',
  components: {
    OrderDetail: _OrderDetail.default,
    VerifyOrderDialog: _VerifyOrderDialog.default
  },
  data: function data() {
    return {
      // 搜索表单数据
      pageFrom: {
        page: 1,
        limit: 20,
        orderNo: '',
        productName: '',
        isWriteOff: '',
        status: '',
        storeType: '',
        payStartTime: '',
        payEndTime: ''
      },
      payTimeRange: [],
      // 表格数据
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      // 店铺类型选项
      storeTypeOptions: [],
      isWriteOffOptions: [{
        value: '',
        label: '全部'
      }, {
        value: 0,
        label: '未核销'
      }, {
        value: 1,
        label: '已核销'
      }],
      // 订单状态选项
      orderStatusOptions: [{
        value: '',
        label: '全部'
      }, {
        value: 0,
        label: '已取消'
      }, {
        value: 1,
        label: '待支付'
      }, {
        value: 2,
        label: '已支付'
      }, {
        value: 3,
        label: '已使用'
      }, {
        value: 4,
        label: '退款中'
      }, {
        value: 41,
        label: '待退款'
      }, {
        value: 5,
        label: '退款成功'
      }, {
        value: 6,
        label: '退款失败'
      }, {
        value: 7,
        label: '部分退款'
      }, {
        value: 10,
        label: '已完结'
      }, {
        value: 15,
        label: '售后中'
      }],
      exportLoading: false
    };
  },
  mounted: function mounted() {
    this.getList();
    this.fetchStoreTypeOptions();
  },
  methods: {
    // 获取列表数据
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              this.syncPayTimeRange();
              _context.n = 2;
              return (0, _rsManagement.getTgAdminOrderList)(this.pageFrom);
            case 2:
              res = _context.v;
              if (res) {
                this.tableData.list = res.list || [];
                this.tableData.total = res.total || 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取订单列表失败：', _t);
              this.$message.error('获取数据失败：' + (_t.message || '未知错误'));
              this.tableData.list = [];
              this.tableData.total = 0;
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 获取店铺类型
    fetchStoreTypeOptions: function () {
      var _fetchStoreTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _rsManagement.getMerchantStoreTypeList)();
            case 1:
              res = _context2.v;
              this.storeTypeOptions = (res || []).filter(function (item) {
                return Number(item.type) === 2;
              });
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取店铺类型失败：', _t2);
              this.storeTypeOptions = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function fetchStoreTypeOptions() {
        return _fetchStoreTypeOptions.apply(this, arguments);
      }
      return fetchStoreTypeOptions;
    }(),
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.pageFrom = {
        page: 1,
        limit: 20,
        orderNo: '',
        productName: '',
        isWriteOff: '',
        status: '',
        storeType: '',
        payStartTime: '',
        payEndTime: ''
      };
      this.payTimeRange = [];
      this.getList();
    },
    handlePayTimeChange: function handlePayTimeChange(range) {
      if (range && range.length === 2) {
        this.pageFrom.payStartTime = range[0];
        this.pageFrom.payEndTime = range[1];
      } else {
        this.pageFrom.payStartTime = '';
        this.pageFrom.payEndTime = '';
      }
    },
    syncPayTimeRange: function syncPayTimeRange() {
      this.handlePayTimeChange(this.payTimeRange);
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageFrom.limit = val;
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.pageFrom.page = val;
      this.getList();
    },
    // 导出订单
    exportOrders: function () {
      var _exportOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.exportLoading = true;
              this.syncPayTimeRange();
              _context3.n = 1;
              return (0, _rsManagement.exportMerchantTgOrderList)(this.pageFrom);
            case 1:
              res = _context3.v;
              if (!(res && res.fileName)) {
                _context3.n = 2;
                break;
              }
              window.open(res.fileName);
              this.$message.success('开始导出');
              return _context3.a(2);
            case 2:
              this.$message.error('导出失败，未获取到下载地址');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.error('导出订单失败：', _t3);
              this.$message.error('导出失败：' + (_t3.message || '未知错误'));
            case 4:
              _context3.p = 4;
              this.exportLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3, 4, 5]]);
      }));
      function exportOrders() {
        return _exportOrders.apply(this, arguments);
      }
      return exportOrders;
    }(),
    // 查看订单
    viewOrder: function viewOrder(row) {
      this.$refs.orderDetailRef.open(row.orderNo);
    },
    // 打开核销弹窗
    openVerifyDialog: function openVerifyDialog(row) {
      this.$refs.verifyOrderDialogRef.open(row);
    },
    // 核销成功回调
    handleVerifySuccess: function handleVerifySuccess() {
      this.getList();
    },
    formatPrice: function formatPrice(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      var num = Number(value);
      return Number.isNaN(num) ? value : num.toFixed(2);
    },
    // 打印小票
    printTicket: function () {
      var _printTicket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row) {
        var printData, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              printData = {
                // printerSn: row.printerSn || '521650237', // 打印机序列号，如果订单数据中没有则使用空字符串
                orderId: row.id,
                // 订单ID
                times: 1 // 默认打印1份
              };
              _context4.n = 1;
              return (0, _rsManagement.printOrderTicket)(printData);
            case 1:
              this.$message.success('小票打印成功');
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.error('打印小票失败：', _t4);
              this.$message.error('打印失败：' + (_t4.message || '未知错误'));
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function printTicket(_x) {
        return _printTicket.apply(this, arguments);
      }
      return printTicket;
    }(),
    // 接单
    _acceptOrder: function () {
      var _acceptOrder2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _rsManagement.acceptOrder)(row.orderNo);
            case 1:
              this.$message.success('接单成功');
              // 刷新列表
              this.getList();
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.error('接单失败：', _t5);
              this.$message.error('接单失败：' + (_t5.message || '未知错误'));
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function _acceptOrder(_x2) {
        return _acceptOrder2.apply(this, arguments);
      }
      return _acceptOrder;
    }(),
    // 退款
    _refund: function () {
      var _refund2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.$confirm("\u786E\u5B9A\u8981\u5BF9\u8BA2\u5355 ".concat(row.orderNo, " \u6267\u884C\u9000\u6B3E\u64CD\u4F5C\u5417\uFF1F\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002"), '退款确认', {
                confirmButtonText: '确认退款',
                cancelButtonText: '再想想',
                type: 'warning',
                confirmButtonClass: 'el-button--danger',
                center: true
              });
            case 1:
              _context6.n = 2;
              return (0, _rsManagement.refund)(row.orderNo);
            case 2:
              this.$message.success("\u8BA2\u5355 ".concat(row.orderNo, " \u9000\u6B3E\u6210\u529F"));
              this.getList();
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              if (_t6 === 'cancel') {
                this.$message.info('已取消退款操作');
              } else {
                console.error('退款失败：', _t6);
                this.$message.error('退款失败：' + (_t6.message || '未知错误'));
              }
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 3]]);
      }));
      function _refund(_x3) {
        return _refund2.apply(this, arguments);
      }
      return _refund;
    }(),
    // 获取订单状态类型
    getOrderStatusType: function getOrderStatusType(status) {
      var statusKey = String(status);
      var statusMap = {
        '0': 'danger',
        // 已取消
        '1': 'warning',
        // 待支付
        '2': 'primary',
        // 已支付
        '3': 'success',
        // 已使用
        '4': 'warning',
        // 退款中
        '41': 'warning',
        // 待退款
        '5': 'success',
        // 退款成功
        '6': 'danger',
        // 退款失败
        '7': 'warning',
        // 部分退款
        '15': 'warning',
        // 售后中
        '10': 'success' // 已完结
      };
      return statusMap[statusKey] || 'info';
    },
    // 获取订单状态文本
    getOrderStatusText: function getOrderStatusText(status) {
      var statusKey = String(status);
      var statusMap = {
        '0': '已取消',
        '1': '待支付',
        '2': '已支付',
        '3': '已使用',
        '4': '退款中',
        '41': '待退款',
        '5': '退款成功',
        '6': '退款失败',
        '7': '部分退款',
        '15': '售后中',
        '10': '已完结'
      };
      return statusMap[statusKey] || '未知状态';
    },
    // 获取物流状态类型
    getLogisticsStatusType: function getLogisticsStatusType(status) {
      var statusMap = {
        '0': 'info',
        // 未发货
        '1': 'primary',
        // 已发货
        '2': 'success' // 签收
      };
      return statusMap[status] || 'info';
    },
    // 获取物流状态文本
    getLogisticsStatusText: function getLogisticsStatusText(status) {
      var statusMap = {
        '0': '未发货',
        '1': '已发货',
        '2': '签收'
      };
      return statusMap[status] || '未知状态';
    },
    getWriteOffStatusType: function getWriteOffStatusType(isWriteOff) {
      var statusMap = {
        '0': 'info',
        '1': 'success'
      };
      return statusMap[String(isWriteOff)] || 'info';
    },
    getWriteOffStatusText: function getWriteOffStatusText(isWriteOff) {
      var statusMap = {
        '0': '未核销',
        '1': '已核销'
      };
      return statusMap[String(isWriteOff)] || '未知';
    }
  }
};